import { TALKER_API_URL } from '~/constants/config';
import { API_TIMEOUT } from '@devhacker/shared/config/general';
import {
  type AxiosLikeFetchResponse,
  createAxiosLikeFetch,
} from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import { parseJsonBigIntIds } from '@devhacker/shared/libs/fetch/parseJsonBigIntIds';
import type { CommentsCountResponse } from '~/types/api/talker';

export const createTalkerApi = ({ $logger }: any) => {
  const talkerFetch = createAxiosLikeFetch({
    baseURL: TALKER_API_URL,
    timeout: API_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
      'x-app': 'lifehacker-web',
    },
    parseResponse: parseJsonBigIntIds, // bigint-safe id + без этого API может вернуть 200 код и html
    ...createLoggerInterceptors($logger, 'talker'),
  });

  return {
    fetchCommentsBySlug(slug: string) {
      const url = `/api/v2/comments/by-post-name/${slug}?format_ver=1&sort=oldest`;
      return talkerFetch(url);
    },
    fetchComments: (
      postId: number,
      limit: number = 4,
      sortType: 'trending' | 'oldest' = 'trending',
    ) => {
      const url = `/api/v2/comments/post/${postId}?sort=${sortType}&format_ver=1&limit=${limit}`;
      return talkerFetch(url);
    },
    fetchAmpComments: (postId: number, sortType: 'trending' | 'oldest' = 'trending') => {
      const url = `/api/v2/comments/post/${postId}?sort=${sortType}&format_ver=1`;
      return talkerFetch(url);
    },

    fetchLastComments: (limit: number = 4) => {
      const url = `/api/comments/last?limit=${limit}`;
      return talkerFetch(url);
    },

    fetchCommentsCount: async (postIds: number[]) => {
      // НЕ УБИРАТЬ!!!
      // это нужно для того, чтобы гугл-бот не падал с ошибкой

      try {
        const url = '/api/comments/count';
        const response = await talkerFetch(url, { params: { post_ids: postIds.join() } });
        return response;
      } catch (error) {
        console.error('fetchCommentsCount', error);
        return {
          success: true,
          data: [],
        };
      }
    },
  };
};
